import React, { useEffect, useLayoutEffect, useState } from 'react';
import styles from './PropertyMessageLogin.scss';
import LoginRegisterToggle from './LoginRegisterToggle';


/* mutable object, counter and streckenzweig1 is mutated in LoginRegisterToggle */
const loginTrackingEvent = {
    'event': 'login_register',
    'event_name': 'login_register',
    'streckenzweig1': 'Registrieren',
    'streckenzweig2': 'Anbieter Kontaktieren',
    'counter': 1,
}

const PropertyMessageLogin: React.FC<React.PropsWithChildren<{ loginHandler: () => void; registerHandler: () => void }>> = ({ loginHandler, registerHandler }) => {

    useLayoutEffect(() => {
        loginTrackingEvent.counter = 1;
        loginTrackingEvent.streckenzweig1 = 'Registrieren';
    }, []);

    // const handleLogin = () => {
    //     loginHandler();
    // };
    // const handleRegister = () => {
    //     registerHandler();
    // };

    return (
        <div className={styles.PropertyMessageLogin}>
            <LoginRegisterToggle
                showTabs={true}
                className={styles.loginRegister}
                showMinimal={true}
                registerHandler={registerHandler}
                loginHandler={loginHandler}
                loginOptions={{
                    description: 'Du bist nicht eingeloggt. Bitte melde dich hier an, damit Deine Kontaktdaten automatisch übernommen werden. Danke!',
                }}
                registerOptions={{
                    description: 'Um Kontakt zu dem Anbieter einer Immobilie aufzunehmen, ist eine einmalige Registrierung bei uns notwendig.',
                    button: 'Neues Benutzerkonto erstellen',
                }}
                trackingEvent={loginTrackingEvent}
            />
        </div>
    );
};

export default PropertyMessageLogin;
